import React, {useState} from "react";
import styles from './preaching.module.css';
import CustomAudioPlayer from "../audio/AudioComponent";
import {EditButton} from "../buttons/EditButton";
import DeleteButton from "../buttons/DeleteButton";
import {getFormattedLocalDate} from "../../services/dateService";
import {usePreachingContext} from "../../context/PreachingContext";
import Text from "../text/Text";

const Preaching = (props) => {

    const {setOpenDelete, setRedacted, setSelectedPreaching} = usePreachingContext();
    const [expanded, setExpanded] = useState(false);

    if (!props.el) return null;

    const isLong = (props.el.description || "").length > 160;

    return (
        <div className={`${styles.card} ${expanded ? styles.cardExpanded : ""}`}>
            <div>
                {props.el.audio_url && (
                    <CustomAudioPlayer src={props.el.audio_url}/>
                )}

                <div style={{fontSize: "20px", fontWeight: "600", marginBottom: "8px"}}>
                    Тема: {props.el.theme}
                </div>

                {props.el.bible_verse && (
                    <div style={{fontSize: "16px", fontWeight: "500", marginBottom: "6px"}}>
                        Основной текст: {props.el.bible_verse}
                    </div>
                )}

                {(props.el.preacher_firstname || props.el.preacher_lastname) && (
                    <div style={{fontSize: "15px", marginBottom: "6px"}}>
                        Кто проповедует: {props.el.preacher_firstname} {props.el.preacher_lastname}
                    </div>
                )}

                {props.el.description && (
                    <div style={{fontSize: "15px", marginBottom: "6px"}}>
                        {isLong ? (
                            <>
                                <div className={`${styles.body} ${expanded ? "" : styles.bodyCollapsed}`}>
                                    <Text text={`<strong>Тезисы:</strong> ${props.el.description}`}/>
                                    {!expanded && <div className={styles.fade}/>}
                                </div>
                                <button type="button" className={styles.expandBtn}
                                        onClick={() => setExpanded((e) => !e)}>
                                    {expanded ? "Свернуть ▲" : "Развернуть ▼"}
                                </button>
                            </>
                        ) : (
                            <Text text={`<strong>Тезисы:</strong> ${props.el.description}`}/>
                        )}
                    </div>
                )}

                {props.el.church && (
                    <div style={{fontSize: "14px", color: "var(--text-muted)"}}>
                        <strong>Церковь:</strong> {props.el.church}
                    </div>
                )}
                <div style={{fontSize: "14px", color: "var(--text-muted)"}}>
                    <strong>Дата проповеди</strong> {getFormattedLocalDate(props.el.preaching_date)}
                </div>
            </div>
            {props.isUserAdmin && (
                <div className={`justify-content-end d-flex`}>
                    <EditButton onClick={() => {
                        setSelectedPreaching(props.el)
                        setRedacted(true)
                    }}/>
                    <DeleteButton onClick={() => {
                        setSelectedPreaching(props.el);
                        setOpenDelete(true);
                    }}
                    />
                </div>
            )}

        </div>

    );
};

export default Preaching;
